export const d4UrlRest = "https://data.power-grid.faker.lei.st";
export const d4BackgroundImage = "/Main_D4c.jpg";
export const d4UrlSchema = "https://schema.power-grid.faker.lei.st/v1"
export const d4UrlType = "https://type.power-grid.faker.lei.st/v1"
export const d4showExplorer1 = false
